import { render, staticRenderFns } from "./DdmStaffExport.vue?vue&type=template&id=127e39ba&scoped=true&"
import script from "./DdmStaffExport.vue?vue&type=script&lang=js&"
export * from "./DdmStaffExport.vue?vue&type=script&lang=js&"
import style0 from "./DdmStaffExport.vue?vue&type=style&index=0&id=127e39ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e39ba",
  null
  
)

export default component.exports